<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="售后订单详情">
        </el-page-header>
        <!-- 订单状态信息 -->
        <div class="order-status" v-if="detailData.order_sn">
            <div class="status-text">
                <span class="order-sn">订单编号：{{ detailData.order_sn }}</span>
            </div>
            <div class="payment-info">
                <div>
                    <div class="payment-status">{{ detailData.status_title }}</div>
                    <div class="payment-tip" v-if="detailData.status == '0'">用户发起退款申请，等待审核中</div>
                    <div class="payment-tip" v-if="detailData.status == '1'">退款申请已通过，等待用户寄回物品</div>
                    <div class="payment-tip" v-if="detailData.status == '4'">已退款，金额原路返回</div>
                </div>
                <div>
                    <el-button type="primary" size="small" @click.stop="handleAgreeRefund()"
                        v-if="detailData.status == '0' || detailData.status == '1'">拒绝退款</el-button>
                    <el-button type="primary" size="small" @click.stop="handleRefuseRefund()"
                        v-if="detailData.status == '0'">同意退款</el-button>
                    <el-button type="primary" size="small" @click.stop="handleConfirmRefund()"
                        v-if="detailData.status == '1'">确认退款</el-button>
                </div>
            </div>
        </div>
        <!-- 退款信息 -->
        <div class="info-section" v-if="detailData.order_sn">
            <div class="info-box">
                <div class="section-title">退款信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">当前状态：</span>
                        <span class="info-value">{{ detailData.status_title }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">服务类型：</span>
                        <span class="info-value">{{ detailData.refund_type_title }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">退款原因：</span>
                        <span class="info-value">{{ detailData.refund_reason }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">退款说明：</span>
                        <span class="info-value">{{ detailData.refund_content }}</span>
                    </div>
                    <div class="info-item" style="display: flex;">
                        <span class="info-label">退款凭证：</span>
                        <div v-for="(ele, index) in detailData.refund_picture" :key="index"
                            style="width: 100px; height: 100px; margin-right: 10px;">
                            <el-image :src="ele" :preview-src-list="detailData.refund_picture"></el-image>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info-left">
                <div class="section-title">收货人信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">收货人：</span>
                        <span class="info-value">{{ detailData.order_info.receiver_name }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">联系电话：</span>
                        <span class="info-value">{{ detailData.order_info.receiver_mobile }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">收货地址：</span>
                        <span class="info-value">{{ detailData.order_info.receiver_address }}</span>
                    </div>
                </div>
            </div>
            <div class="info-right">
                <div class="section-title">付款信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">付款方式：</span>
                        <span class="info-value">{{ detailData.pay_type }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">付款金额：</span>
                        <span class="info-value">{{ detailData.payable_money }}</span>
                    </div>
                </div>
            </div>
            <div class="info-box">
                <div class="section-title">订单信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">订单备注：</span>
                        <span class="info-value">{{ detailData.order_info.remark || '无' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">订单编号：</span>
                        <span class="info-value">{{ detailData.order_sn }} <span class="copy-btn"
                                @click="copyText(detailData.order_sn)">复制</span></span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">下单时间：</span>
                        <span class="info-value">{{ detailData.create_time }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">支付时间：</span>
                        <span class="info-value">{{ detailData.pay_time }}</span>
                    </div>
                </div>
            </div>
        </div>
        <el-table :data="goods" :border="true" style="width: 100%" class="order-table">
            <el-table-column label="商品名称" width="400" align="center">
                <template slot-scope="scope">
                    <div class="goods-info">
                        <img :src="scope.row.goods_thumb" alt="" class="goods-image" />
                        <div class="goods-details">
                            <div class="goods-name">{{ scope.row.goods_name }}</div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div class="goods-spec">{{ scope.row.sku_name }}</div>
                                <div class="goods-price">
                                    <span>¥{{ scope.row.price }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="goods_num" label="数量" align="center" />
            <el-table-column prop="name" label="买家" align="center" />
            <el-table-column prop="payable_money" label="金额" align="center">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import ViewLogistics from '@/components/ViewLogistics.vue'
export default {
    name: 'AfterOrderDetail',
    components: {
        ViewLogistics,
    },
    props: {
        after_id: {
            type: [String, Number],
            default: ''
        },
        partner_id: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            detailData: {
                aid: '',
            },  // 详情列表
            goods: [],
        }
    },
    mounted() {
        this.getAfterOrderDetail();
    },
    methods: {
        // 确认退款 
        handleConfirmRefund() {
            this.$confirm('确定退款吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.confirmRefund({
                    refund_id: this.after_id
                }).then(res => {
                    this.$message.success('退款成功');
                    this.getAfterOrderDetail();
                }).catch(err => {
                    this.$message.warning(err)
                })
            })
        },
        // 同意退款
        handleAgreeRefund() {
            this.$confirm('确认同意退款？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.agreeRefund({
                    refund_id: this.after_id
                }).then(res => {
                    this.$message.success('同意退款成功');
                    this.getAfterOrderDetail();
                }).catch(err => {
                    this.$message.warning(err)
                })
            })
        },
        // 拒绝退款
        handleRefuseRefund() {
            this.$prompt('请填写拒绝原因？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(({ value }) => {
                if (!value) {
                    this.$message.warning('请输入拒绝原因');
                    return;
                }
                this.$api.refuseRefund({
                    refund_id: this.after_id,
                    reject_reason: value
                }).then(res => {
                    this.$message.success('拒绝退款成功');
                    this.getAfterOrderDetail();
                }).catch(err => {
                    this.$message.warning(err)
                })
            })
        },
        goBack() {
            this.$emit('goToComponent', 'AfterOrderList');
        },
        // 获取售后订单详情
        getAfterOrderDetail() {
            this.$api.getShopAfterOrderDetail({
                id: this.after_id,
            }).then(res => {
                this.detailData = res;
                this.goods = [{
                    goods_thumb: this.detailData.goods_thumb,
                    goods_name: this.detailData.goods_name,
                    sku_name: this.detailData.sku_name,
                    goods_num: this.detailData.goods_num,
                    price: this.detailData.sku_shop_price,
                    name: this.detailData.user_nickname + ' ' + this.detailData.mobile,
                    payable_money: this.detailData.payable_money,
                }]
            })
        },
        // 复制文本到剪贴板
        copyText(txt) {
            navigator.clipboard.writeText(txt)
                .then(() => {
                    this.$message.success('复制成功');
                })
                .catch(err => {
                    console.error('复制失败:', err);
                    this.$message.warning('复制失败');
                });
        }
    }
}
</script>

<style scoped>
.order-detail {
    padding: 20px;
    background-color: #fff;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 订单状态区域 */
.order-status-section {
    margin-bottom: 20px;
}

.order-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
}

.order-status {
    text-align: left;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 15px;
}

.status-text {
    margin-bottom: 10px;
}

.status-label {
    font-size: 14px;
    color: #333;
    margin-right: 20px;
}

.order-sn {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.payment-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: end;
}

.payment-status {
    font-weight: bold;
    font-size: 16px;
    color: #286CED;
}

.payment-tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
}

.payment-time {
    font-size: 14px;
    color: #666;
}

.time-value {
    color: #e74c3c;
    font-weight: 500;
}

.order-tip {
    font-size: 12px;
    color: #999;
    line-height: 1.5;
}

/* 信息区域 */
.info-section {
    display: flex;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
}

.info-box {
    width: 100%;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
}

.info-left,
.info-right {
    width: calc(50% - 10px);
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    /* padding: 15px; */
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    background: #FAFAFA;
    color: #333;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    padding: 10px 15px;
}

.section-title::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 16px;
    background-color: #286CED;
    margin-right: 8px;

}

.info-content {
    font-size: 14px;
    text-align: left;
    padding: 0px 15px 0px 15px;
}

.info-item {
    margin-bottom: 10px;
}

.info-label {
    color: #666;
    margin-right: 10px;
}

.info-value {
    color: #333;
}

.copy-btn {
    color: #286CED;
    cursor: pointer;
    margin-left: 10px;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
}

.goods-details {
    min-height: 80px;
    flex: 1;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

.money_box {
    display: flex;
    flex-direction: column;
    align-items: end;
    margin-top: 20px;
}

.money-item {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
}

.payable-txt {
    font-weight: bold;
    font-size: 20px;
    color: #F02325;
    margin-left: 2px;
}

.dialog-content {
    width: 100%;
}

.form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    label {
        font-weight: 400;
        font-size: 14px;
        color: #221E1F;
        margin-bottom: 16px;
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .info-section {
        flex-direction: column;
    }

    .product-header,
    .product-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .product-info,
    .product-quantity,
    .product-buyer,
    .product-amount,
    .product-status,
    .product-operation {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
    }
}
</style>